import { GoogleAnalytics } from '@next/third-parties/google';
import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ReduxProvider } from 'src/provider/ReduxProvider';
import router from 'src/routes';

import { GA_ID } from './global/config/common.config';
import { NetworkProvider } from './provider/NetworkProvider';
import { Web3Provider } from './provider/Web3Provider';

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong.</h1>
          <p>{error instanceof Error ? error.message : 'An unknown error occurred'}</p>
          <button onClick={resetError} style={{ marginTop: '10px', padding: '10px 20px' }}>
            Try again
          </button>
        </div>
      )}>
      <ReduxProvider>
        <GoogleAnalytics gaId={GA_ID} />
        <NetworkProvider>
          <Web3Provider>
            <RouterProvider router={router} />
            <ToastContainer />
          </Web3Provider>
        </NetworkProvider>
      </ReduxProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
